import { useTranslation } from 'react-i18next'
import { Stepper } from '@chillout/ui'

interface PerMealInputProps {
  value: number
  onChange: (value: number) => void
  max: number
}

export function PerMealInput({ value, onChange, max }: PerMealInputProps) {
  const { t } = useTranslation()

  const countLabel = value === 1
    ? t('stampAwarding.stampCountSingle')
    : t('stampAwarding.stampCount', { count: value })

  return (
    <Stepper
      value={value}
      onChange={onChange}
      max={max}
      label={t('stampAwarding.perMeal.label')}
      countLabel={countLabel}
      decrementAccessibilityLabel={t('stampAwarding.perMeal.decrementAccessibilityLabel')}
      incrementAccessibilityLabel={t('stampAwarding.perMeal.incrementAccessibilityLabel')}
      countAccessibilityLabel={t('stampAwarding.perMeal.countAccessibilityLabel', { count: value })}
    />
  )
}